import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { contactRGPD } from './Mandat';

function CGU() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen dark:bg-fond-sombre">
      <Header/>

      <main className="flex-grow max-w-4xl mx-auto p-6 space-y-6 mb-16">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gris-sombre dark:text-blanc-sombre text-center mt-12">Conditions Générales d’Utilisation (CGU)</h1>
        <p className="text-1xl font-bold text-gray-800 dark:text-blanc-sombre text-center">Dernière mise à jour : 21 mars 2026</p>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Objet</h2>
          <p className="dark:text-blanc-sombre">
            Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet de définir les règles applicables à l’accès et à
            l’utilisation du site <a href="https://www.junior-i2c.com" className="text-blue-600 underline">https://www.junior-i2c.com</a> (ci-après « le site ») édité par Ingénierie et Conseil en Cognitique (i2c).<br/>
            <br/>
            En accédant au site, l’utilisateur reconnaît avoir pris connaissance de ces CGU et les accepter sans réserve.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Accès au site</h2>
          <p className="dark:text-blanc-sombre">
            Le site est accessible gratuitement à tout utilisateur disposant d’un accès à Internet.<br/>
            L’éditeur se réserve le droit de modifier, suspendre ou interrompre l’accès au site, temporairement ou définitivement,
            sans préavis ni indemnité.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Contenu du site</h2>
          <p className="dark:text-blanc-sombre">
            Les informations, textes, images, vidéos, logos et autres éléments présents sur le site sont fournis à titre informatif
            et sont protégés par le droit d’auteur.<br/>
            Toute reproduction, modification, distribution ou utilisation de ces contenus sans autorisation écrite préalable est
            strictement interdite.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Responsabilités</h2>
          <p className="dark:text-blanc-sombre">
            i2c met tout en œuvre pour assurer l’exactitude des informations publiées. Toutefois, l’éditeur ne peut être tenu
            responsable :<br/>
            • des erreurs, omissions ou inexactitudes présentes sur le site ;<br/>
            • des dommages directs ou indirects résultant de l’accès ou de l’utilisation du site ;<br/>
            • des contenus ou liens externes vers d’autres sites.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Utilisation du site</h2>
          <p className="dark:text-blanc-sombre">
            L’utilisateur s’engage à :<br/>
            • ne pas perturber le fonctionnement du site ;<br/>
            • ne pas tenter d’accéder à des zones non autorisées ;<br/>
            • ne pas diffuser de contenus illicites, diffamatoires, injurieux ou contraires aux lois en vigueur.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Données personnelles</h2>
          <p className="dark:text-blanc-sombre">
            Le traitement des données collectées via notre formulaire de contact respecte le Règlement Général
            sur la Protection des Données (RGPD) ainsi que les droits des utilisateurs qui sont détaillés dans
            notre <span onClick={() => { navigate('/politique-de-confidentialite'); window.scrollTo(0, 0); }} className="text-blue-600 underline cursor-pointer">Politique de confidentialité</span>.
            Pour exercer vos droits, contactez-nous à l’adresse e-mail : <a href={`mailto:${contactRGPD.mail}`} className="text-blue-600 underline">{contactRGPD.mail}</a>
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Cookies</h2>
          <p className="dark:text-blanc-sombre">
            Le site utilise exclusivement un cookie technique nécessaire à votre confort de navigation, servant à mémoriser votre
            préférence d'affichage (mode clair ou sombre). Aucun cookie publicitaire ou de mesure d'audience n'est utilisé.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Modification des CGU</h2>
          <p className="dark:text-blanc-sombre">
            i2c se réserve le droit de modifier les présentes CGU à tout moment.
            Les utilisateurs sont invités à les consulter régulièrement.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Litiges</h2>
          <p className="dark:text-blanc-sombre">
            Tout litige relatif à l’interprétation ou à l’application des présentes CGU sera soumis au droit français et aux
            juridictions compétentes.
          </p>
        </section>
      </main>

      <Footer/>
    </div>
  );
}

export default CGU;